<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <user-roles>
        </user-roles> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import userRoles from './todo-user-roles'
export default {
    components: {
        userRoles
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-user-roles/base-user-roles.vue